<div #page>
  <small class="my-5" [innerHTML]="'partner_setup_manual_description' | translate"></small>
  <form class="mt-4" [formGroup]="newReferralFrom">
    <div class="page__form-wrap">
      <div class="form-group row">
        <label for="companyName" class="col-sm-4" translate>account_company</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="companyName"
            formControlName="companyName"
            wsbAppControlValidator
            [fc]="newReferralFrom.get('companyName')"
          />
          <wsb-validation-error-msg [fc]="newReferralFrom.get('companyName')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row">
        <label for="registrationEmail" class="col-sm-4" translate>account_username</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="registrationEmail"
            formControlName="registrationEmail"
            wsbAppControlValidator
            [fc]="newReferralFrom.get('registrationEmail')"
          />
          <wsb-validation-error-msg [fc]="newReferralFrom.get('registrationEmail')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row">
        <label for="name" class="col-sm-4" translate>account_name</label>
        <div class="col-sm-8 ">
          <input
            type="text"
            class="form-control"
            id="name"
            formControlName="name"
            wsbAppControlValidator
            [fc]="newReferralFrom.get('name')"
          />
          <wsb-validation-error-msg [fc]="newReferralFrom.get('name')"></wsb-validation-error-msg>
        </div>
      </div>
      <div class="form-group row">
        <label for="surname" class="col-sm-4" translate>account_surname</label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            id="surname"
            formControlName="surname"
            wsbAppControlValidator
            [fc]="newReferralFrom.get('surname')"
          />
          <wsb-validation-error-msg [fc]="newReferralFrom.get('surname')"></wsb-validation-error-msg>
        </div>
      </div>

      <div class="form-group row">
        <label for="mobileNumber" class="col-sm-4" translate>account_cell</label>
        <div class="col-sm-8">
          <ng-container>
            <wsb-atlas-inputphone
              #inputPhone
              name="number"
              [cssClass]="'form-control'"
              [formControlName]="'mobileNumber'"
            ></wsb-atlas-inputphone>
            <wsb-validation-error-msg [fc]="inputPhone.phoneNumber"></wsb-validation-error-msg>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
  <div class="page__actions  actions-bar" #actionsBar style="z-index: 1" *ngIf="newReferralFrom">
    <span class="actions-bar__bg"></span>
    <div class="actions-bar__container" toastContainer></div>
    <div class="actions-bar__container  actions-bar__container--actions">
      <div class="d-flex">
        <div class="d-flex w-50">
          <button
            #submitBtn
            class="btn btn-primary btn-sm"
            [disabled]="newReferralFrom.pristine || newReferralFrom.invalid"
            (click)="onSubmit()"
            translate
          >
            common_save
          </button>
          <button *ngIf="newReferralFrom.dirty" type="button" class="btn btn-link btn-sm ms-2" (click)="onResetForm()" translate>
            common_cancel
          </button>
        </div>
      </div>
      <div *ngIf="!newReferralFrom.pristine" class="mt-2">
        <small translate>settings_subaccounts_mandatory_field</small>
      </div>
    </div>
  </div>
</div>
